import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import HeroSection from "./sections/HeroSection";
import QualificationCriteria from "./sections/QualificationCriteria";
import EnrollmentForm from "./sections/EnrollmentForm";
import RoiCalculator from "./sections/RoiCalculator";
import HowItWorks from "./sections/HowItWorks";
import TheScienceOfRelaxedBuying from "./sections/TheScienceOfRelaxedBuying";
import AbsoluteConsolidation from "./sections/AbsoluteConsolidation";
import ThreeXPackageIncrease from "./sections/3XPackageIncrease";
import PrepayqrDifference from "./sections/PrepayqrDifference";
import OperationalIntegrity from "./sections/OperationalIntegrity";
import AiSpaAssistant from "./sections/AiSpaAssistant";
import SpeakToARealPerson from "./sections/SpeakToARealPerson";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import FinalCta from "./sections/FinalCta";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <HeroSection />
      <QualificationCriteria />
      <EnrollmentForm />
      <RoiCalculator />
      <HowItWorks />
      <TheScienceOfRelaxedBuying />
      <AbsoluteConsolidation />
      <ThreeXPackageIncrease />
      <PrepayqrDifference />
      <OperationalIntegrity />
      <AiSpaAssistant />
      <SpeakToARealPerson />
      <FrequentlyAskedQuestions />
      <FinalCta />
      <Footer />
    </div>;
}